import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=2fc01ba2&scoped=true"
import script from "./ImageEditor.vue?vue&type=script&lang=ts"
export * from "./ImageEditor.vue?vue&type=script&lang=ts"
import style0 from "./ImageEditor.vue?vue&type=style&index=0&id=2fc01ba2&prod&lang=scss&scoped=true"
import style1 from "./ImageEditor.vue?vue&type=style&index=1&id=2fc01ba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc01ba2",
  null
  
)

export default component.exports